import { apiService } from "./apiService";
import { endpoints } from "../config/endpoints";

export default {
  getGmbServicesList(params) {
    return apiService
      .post(endpoints.gmbServicesList, params)
      .then(({ data }) => {
        const [{ service_types: serviceTypes }] = data;

        const mappedServiceTypes = serviceTypes.map(serviceType => ({
          gmb_service_type: serviceType
        }));

        return { service_types: mappedServiceTypes };
      });
  },
  getGmbServicesWithCategories(params) {
    return apiService.post(endpoints.gmbServicesList, params);
  },
  getGmbServicesListFreeForm(params) {
    return apiService.get(endpoints.gmbServicesListFreeForm, {
      params
    });
  }
};
